var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 16 16"}},_vm._l((_vm.paths),function(path){return _c('path',{attrs:{"fill":path.fill,"d":path.d}})}))}
var staticRenderFns = []

export { render, staticRenderFns }